import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, of, retry, switchMap, throwError } from 'rxjs';
import { CartService } from '../../../services/cart/cart.service';
import { StripeService } from '../../../services/stripe/stripe.service';

@Component({
  selector: 'lib-stripe-payment-success',
  templateUrl: './stripe-payment-success.component.html',
  styleUrls: ['./stripe-payment-success.component.css'],
  standalone: false
})
export class StripePaymentSuccessComponent implements OnInit {
  protected stripeService = inject(StripeService);
  protected route = inject(ActivatedRoute);
  protected router = inject(Router);
  protected cartService = inject(CartService);
  
  orderContextId = '';
  retryLimit = 1;

  ngOnInit() {
    this.cartService.clearCart();
    const queryParams = this.route.snapshot.queryParams;

    if (!!queryParams && queryParams.storageId) {
      this.stripeService
        .getOrderStripe(queryParams.storageId)
        .pipe(
          switchMap(orderContextStripe => {
            if (!orderContextStripe || !orderContextStripe.id) {
              return throwError(() => new Error('ID null'));
            }
            return of(orderContextStripe);
          }),
          retry({
            count: this.retryLimit, 
            delay: 2000 
          }),
          catchError(err => {
            console.error('null ID after retry', err);
            return [];
          })
        )
        .subscribe(orderContextStripe => {
          console.log(orderContextStripe);
          this.orderContextId = orderContextStripe.id;
          this.router.navigateByUrl('order-confirmation/' + this.orderContextId + '?stripe=success');
        });
    }
  }
}
